// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MHvD","content":"styles_content__16u8w","row":"styles_row__IXX5N","footer":"styles_footer__1nEOB","phraseLength":"styles_phraseLength__3C0-6"};